import { Component, h } from 'preact';
import * as appStyles from '../../../assets/global.scss';
import Icon from '../../../common/Icon/Icon';
import { Properties, AmDurationItem, getKey, Key } from '../../../common';
import { Row } from '../../../common/Layout/Layout';
import { withStyles, WithStyles } from '../../../style';
import { stopPropagation, isRadio } from '../../../utils';

export interface DurationRadioProps extends Properties {
  item: AmDurationItem;
  checked: boolean;
  onSelection: (item: AmDurationItem) => any;
}

type EffectiveProps = DurationRadioProps & WithStyles;

@withStyles(appStyles)
export default class DurationRadio extends Component<DurationRadioProps> {
  setTravelClass = (e: MouseEvent): void => {
    const { onSelection, item } = this.props;
    onSelection(item);

    // As navigating radio buttons with arrowKeys will fire click events
    // we check whether or not the event originates from keyboard navigation
    // (radio) or normal click and close the modal only if it's a genuine click
    if (!isRadio(e.target as HTMLElement)) {
      this.hideModal();
    }
  };

  handleKeyUp = (e: KeyboardEvent) => {
    if (getKey(e) === Key.ENTER) {
      stopPropagation(e);
      this.hideModal();
    }
  };

  hideModal = (): void => {
    const {
      modal: { hideModal },
    } = this.context;
    hideModal();
  };

  render({ item, checked, tx }: EffectiveProps): h.JSX.Element {
    return (
      <Row
        class={tx(this.props.class, `durationItem-${item.code}`, 'flex--space-between')}
        grow={false}
        fill={false}
        onClick={this.setTravelClass}
      >
        <input
          class={'is-vishidden'}
          id={`durationItem-${item.code}`}
          type="radio"
          name="travelClass"
          value={item.code}
          onKeyUp={this.handleKeyUp}
          checked={checked}
          autofocus={checked}
        />
        <label
          for={`travelClass-${item.code}`}
          class={tx('cursor-pointer', 'font-body-1 ps-medium-y fill', {
            'nordic-blue-900-text': checked,
          })}
        >
          {item.label}
        </label>
        {checked && <Icon class={tx('is-small heather-700-text')} iconName="checkmark" />}
      </Row>
    );
  }
}
